module.exports = __webpack_public_path__ + "img/792.c97f6e23.jpg";